export function addDisplayName(func, displayName) {
    var _a;
    const funcAny = func;
    if (((_a = funcAny.$$typeof) === null || _a === void 0 ? void 0 : _a.toString()) === "Symbol(react.memo)") {
        funcAny.type.displayName = displayName;
    }
    funcAny.displayName = displayName;
}
